<template>
  <div class="jygl">
    <div class="line1">
      <div class="content w-70">
        <div class="top" v-if='summary1'><div class="icon"></div>销售趋势（总店铺数：{{summary1.shopTotalQuantity}}家）,已授权店铺：{{summary1.authorizedShopQuantity}}家</div>
        <div class="title" v-if='summary1'>
          <div>销售总金额：{{summary1.tradeTotalAmount}}万</div>
          <div>订单笔数：{{summary1.orderTotalQuantity}}单</div>
        </div>
        <div id="jygl-charts1"></div>
      </div>
      <div class="content w-30">
        <div class="top">
          <div class="icon"></div>
          集中度情况
          <div class="right">
            <el-radio-group v-model="tabPosition" @change="initCharts2" style="margin-bottom: 30px;">
              <el-radio-button label="1">店铺</el-radio-button>
              <el-radio-button label="2">主体</el-radio-button>
              <el-radio-button label="3">平台</el-radio-button>
              <el-radio-button label="4">国家/区</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="title" style="margin-top:32px;" v-if="tabPosition == 1 && summary2">
          <div>店铺总数：{{summary2.totalAccountNum || 0}}家</div>
          <div>已授权店铺：{{summary2.authAccountNum || 0}}家</div>
        </div>
        <div class="title" style="margin-top:32px;" v-if="tabPosition == 2 && summary2">
          <div>主体数量：{{summary2.mainNum || 0}}个</div>
        </div>
        <div class="title" style="margin-top:32px;" v-if="tabPosition == 3 && summary2">
          <div>平台数量：{{summary2.platformNum || 0}}个</div>
        </div>
        <div  id="jygl-charts2"></div>
      </div>
    </div>
    <div class="line1">
      <div class="content w-100">
        <div class="top"><div class="icon"></div>运营支出 （单位：万元）</div>
        <div class="title" >
          <div>店铺总数：{{summary1.shopTotalQuantity}}家</div>
          <div>已授权店铺：{{summary1.authorizedShopQuantity}}家</div>
          <div>销售额：{{summary1.tradeTotalAmount}}万</div>
          <div>运营支出总额：{{summary1.totalExpend}}万</div>
        </div>
        <div class="row">
          <div class="tips" ><div style="margin-bottom:4px">{{tips}}%</div><div>费用占比</div></div>
          <div id="jygl-charts4"></div>
          <div id="jygl-charts5"></div>
        </div>
      </div>
    </div>
    <div class="line1">
      <div class="content w-33">
        <div class="top"><div class="icon"></div>配送统计</div>
        <div class="title" v-if="summary6 && Object.keys(summary6).length">
          <div>配送次数：{{summary6.All || 0}}次</div>
          <div>配送商品件数：{{summary6.number || 0}}件</div>
        </div>
        <div id="jygl-charts6"></div>
      </div>
      <div class="content w-33">
        <div class="top"><div class="icon"></div>报关统计</div>
        <div class="title" v-if="declareSummary && Object.keys(declareSummary).length">
          <div>报关单数：{{declareSummary.customsTimes}}单</div>
          <div>报关商品件数：{{declareSummary.customsCommoditiesPiece}}件</div>
        </div>
        <div id="jygl-charts7"></div>
      </div>
      <div class="content w-33">
        <div class="top"><div class="icon"></div>仓储库存统计</div>
        <div class="title">
          <div>库存数量：{{enterpriseGoodsStored.availableQty || 0 | formatNumber}}件</div>
          <div>库存金额：{{enterpriseGoodsStored.totalPrice || 0 | formatNumber}}元</div>
        </div>
        <div class="title">
          <div>平均周转率：{{enterpriseGoodsStored.stockTurnover || 0}}</div>
          <div>存销比：{{enterpriseGoodsStored.inventorySalesRate || 0}}</div>
        </div>
        <div  id="jygl-charts8"></div>
      </div>
    </div>
    <div class="line1">
      <div class="content w-50" style="margin-right:20px;">
        <div class="top"><div class="icon"></div>授信统计 （单位：万元）</div>
        <div class="row">
          <div class="texts">
            <div>授信总额：{{enterpriseLoans.creditAmount || 0 | formatNumber}}万元</div>
            <div>累计贷款：{{enterpriseLoans.loanAmount || 0 | formatNumber}}万元</div>
            <div>现有贷款：{{enterpriseLoans.loanBalance || 0 | formatNumber}}万元</div>
            <div>剩余授信：{{enterpriseLoans.creditBalance || 0 | formatNumber}}万元</div>
            <div>逾期金额：{{enterpriseLoans.overdueInterests || 0 | formatNumber}}万元</div>
            <div>金融机构：{{enterpriseLoans.orgNum || 0 | formatNumber}}家</div>
          </div>
          <div id="jygl-charts9"></div>
        </div>
      </div>
      <div class="content w-50">
        <div class="top"><div class="icon"></div>结算统计 （单位：万元）</div>
        <div class="row">
          <div class="texts">
            <div>结算总额： {{enterpriseAccountSummary.settledTotal || 0 | formatNumber}}万元</div>
            <div>结算商品： {{enterpriseAccountSummary.productNum || 0 | formatNumber}}个</div>
            <div>结算笔数： {{enterpriseAccountSummary.settledCount || 0 | formatNumber}}笔</div>
          </div>
          <div id="jygl-charts10"></div>
        </div>
      </div>
    </div>
    <el-dialog
      title="商品列表"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class='commonDialog'
      :visible.sync="modelShow"
      width="80%"
    >
      <div class='mask'></div>
      <div class='ux-panel'>
        <div class='title'>商品列表</div>
        <!-- <div class="head-list">
          <div v-for="(item, index) in headList" :key="index">
            {{item.name}}{{item.value}}{{item.unit}}
          </div>
        </div> -->
        <div class='ux-tabs tabs'>
          <div class="ux-filter-records filter-records">
            <div class='content-list'>
              <el-table
                class="table ux-dark-el-table"
                :data="scoretableData"
                empty-text="暂无数据"
                element-loading-spinner="el-icon-loading">
                  <el-table-column show-overflow-tooltip v-for="(props, i) in scoretableHeader" :label='props.label' align="center" :key="i">
                    <template slot-scope="scope">
                      <div v-if="props.type">
                        {{((page.current - 1) * page.size) + scope.$index + 1}}
                      </div>
                      <div v-else class="text">{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column width="120" label='商品评分' align="center">
                    <template slot-scope="scope">
                      <div class="blue">商品评分</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div class='pages'>
              <span>共 {{ scorepage.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="scorepage.current"
                :page-size="scorepage.size"
                :total="scorepage.total"
                @current-change="scorecurrentChange"
              />
              <pagination @currentChange="scorecurrentChange" @sizeChange="scoresizeChange"/>
            </div>
          </div>
        </div>
        <div class='close' @click='modelShow = false'>
          <img src='@/assets/images/home/close.png'/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import apiPath from '@config/api.json'
import { Loading } from 'element-ui'
const {mapState, mapMutations} = require('vuex')
export default {
  components: { pagination },
  props: ['info'],
  data () {
    return {
      menuItem: {
        searchProductRating: false, // 搜索-查看经营概览-评分分析
        searchStoreRating: false // 搜索-查看经营概览-店铺评分
      },
      tabPosition: '1',
      summary1: {},
      summary2: [],
      summary3: {},
      summary4: '',
      summary5: {},
      summary6: '',
      summary7: {},
      summary8: {},
      summary9: {},
      modelShow: false,
      scpreinfo: {},
      scoretableData: [],
      headList: [],
      scoretableHeader: [
        {
          type: 'index',
          label: '序号'
        },
        {
          prop: 'productId',
          label: '商品ID'
        },
        {
          prop: 'productName',
          label: '商品名称'
        },
        {
          prop: 'productPrice',
          label: '售价（元）'
        },
        {
          prop: 'tradeTotalAmount',
          label: '销售总额（元）'
        },
        {
          prop: 'productQuantity',
          label: '销量（件）'
        },
        {
          prop: 'shopName',
          label: '所属店铺'
        },
        {
          prop: 'sysSource',
          label: '所属平台'
        },
        {
          prop: 'tradeTotalAmount',
          label: '销售总金额'
        }
      ],
      scorepage: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      tableHeader: [
        // {
        //   type: "index",
        //   label: "排名",
        // },
        {
          prop: 'productName',
          label: '商品名称'
        },
        {
          prop: 'productPrice',
          label: '售价（元）'
        },
        {
          prop: 'tradeTotalAmount',
          label: '销售总额（元）'
        },
        {
          prop: 'tradeQuantity',
          label: '销量（件）'
        }
      ],
      tips: 0,
      tipsShow: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      colors: ['rgb(236,154,86)', 'rgb(230,202,95)', 'rgb(107,215,156)', 'rgb(138,63,243)', 'rgb(81,163,192)', 'rgb(66,101,203)', 'rgb(53,54,180)', 'rgb(149,78,220)', 'rgb(187,143,182)', 'rgb(206,108,118)'],
      list: [],
      customerNo: 'AAA4',
      urlApi: '',
      enterpriseAccountSummary: {},
      enterpriseGoodsStored: {},
      enterpriseLoans: {},
      declareSummary: {}

    }
  },

  computed: {
    ...mapState({
      searchDate: (state) => {
        return state.home.searchDate
      }
    })
  },

  watch: {
    searchDate: function (n) {
      this.init()
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.searchProductRating = common.isShowItem('searchProductRating', setListMenu)
      this.menuItem.searchStoreRating = common.isShowItem('searchStoreRating', setListMenu)
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    ...mapMutations(),
    init () {
      this.getOrderSalesSummary()
      // listSalesTrend
      this.initCharts1()
      // listConcentration
      this.initCharts2()
      // listProductAmount
      // listShopAmount
      // this.initCharts3()
      // listOperatingExpenses
      // this.initCharts4()
      this.getOrderSalesTrend()
      // listBusinessStatistics
      this.initCharts6()
      // this.initCharts7()
      // this.initCharts8()
      // this.initCharts9()
      // this.initCharts10()
      // 运营支出汇总表
      this.initCharts4()
      // 仓储库存统计
      this.loadEnterpriseGoodsStored()
      // 企业结算汇总表
      this.loadEnterpriseAccountSummary()
      // 授信统计
      this.loadEnterpriseLoans()
      // 报关统计
      this.loadDeclareSummary()
    },
    getOrderSalesSummary () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.order.getOrderSalesSummary}/${this.info.customerNo}`
        // url: `${apiPath.bigData.search.order.getOrderSalesSummary}/AABK`
      }).then(res => {
        if (res.data) {
          let data = res.data
          this.summary1.shopTotalQuantity = data.storesNum
          this.summary1.authorizedShopQuantity = data.authStoresNum
          this.summary1.tradeTotalAmount = (data.transaction / 10000).toFixed(2)
          this.summary1.orderTotalQuantity = data.orderNum
          this.summary1.totalExpend = Math.abs((data.totalExpend / 10000).toFixed(2))
          this.$forceUpdate()
        }
      })
    },
    // getScope (item) {
    //   this.scorepage = {
    //     current: 1,
    //     size: 10,
    //     total: 0
    //   }
    //   this.scpreinfo = item
    //   this.getScopeList()
    // },
    getScopeList () {
      const loadTips = Loading.service()
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.listScoringAnalysis}`,
        data: {
          'companyName': this.info.companyName,
          'pageNum': this.scorepage.current,
          'pageSize': this.scorepage.size,
          'searchDate': this.searchDate,
          'searchParam': '',
          'sortParam': '',
          'yearTime': this.searchDate,
          'productName': this.scpreinfo.productName
        }
      }).then(res => {
        loadTips.close()
        if (res) {
          this.scoretableData = res.data || []
          this.scorepage.total = res.total || 0
        }
        this.modelShow = true
      })
    },
    scorecurrentChange (e) {
      this.scorepage.current = e
      this.getScopeList()
    },
    scoresizeChange (e) {
      this.scorepage.current = 1
      this.scorepage.size = e
      this.getScopeList()
    },
    change (e) {
      this.page.current = e
      this.getList()
    },
    sizechange (e) {
      this.page.current = 1
      this.page.size = e
      this.getList()
    },
    getList () {
      const loadTips = Loading.service()
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.listProductAmount}`,
        data: {
          'companyName': this.info.companyName,
          'pageNum': this.page.current,
          'pageSize': this.page.size,
          'searchDate': this.searchDate,
          'searchParam': '',
          'sortParam': '',
          'yearTime': this.searchDate
        }
      }).then(res => {
        loadTips.close()
        if (res) {
          this.tableData = res.data || []
          this.page.total = res.total || 0
        }
      })
    },
    initCharts1 () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.jygl.getOrderSalesTrend}/${this.info.customerNo}`
        // url: `${apiPath.bigData.search.jygl.getOrderSalesTrend}/AABK`
        // data: {
        //   'companyName': this.info.companyName,
        //   'pageIndex': 1,
        //   'pageSize': 10,
        //   'searchDate': this.searchDate,
        //   'searchParam': '',
        //   'sortParam': '',
        //   'yearTime': this.searchDate
        // }
      }).then(res => {
        let tradeList = res.data
        let monthTime = []
        let data1 = []
        let data2 = []
        let n2 = 0
        tradeList.forEach(item => {
          monthTime.push(item.monthDay)
          data1.push(item.orderNum)
          data2.push((item.transaction / 10000).toFixed(2))
          n2 += item.orderNum
        })
        // this.summary1.tradeTotalAmount = n1
        this.summary1.orderTotalQuantity = n2
        var chartDom = document.getElementById('jygl-charts1')
        var myChart = this.$echarts.init(chartDom)
        let data = ['订单', '销售额']
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          grid: {
            top: '10%',
            left: '2%',
            right: '2%',
            bottom: '0%',
            containLabel: true
          },
          legend: {
            data: data,
            textStyle: {
              color: '#fff'
            }
          },
          xAxis: [
            {
              type: 'category',
              data: monthTime,
              axisPointer: {
                type: 'shadow'
              },
              axisLabel: {
                textStyle: {
                  color: '#fff'
                }
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: data[0],
              // min: 0,
              // max: 250,
              // interval: 50,
              axisLabel: {
                formatter: '{value} 单',
                textStyle: {
                  color: '#fff'
                }
              }
            },
            {
              type: 'value',
              name: data[1],
              // min: 0,
              // max: 25,
              // interval: 5,
              axisLabel: {
                formatter: '{value} 万',
                textStyle: {
                  color: '#fff'
                }
              }
            }
          ],
          series: [
            {
              name: data[0],
              type: 'bar',
              tooltip: {
                valueFormatter: function (value) {
                  return value + ' 单'
                }
              },
              barWidth: 16,
              data: data1
            },
            {
              name: data[1],
              type: 'line',
              yAxisIndex: 1,
              tooltip: {
                valueFormatter: function (value) {
                  return value + ' 万'
                }
              },
              data: data2
            }
          ]
        }
        option && myChart.setOption(option)
      })
    },
    async initCharts2 () {
      this.summary2 = []
      switch (this.tabPosition) {
        case '1':
          this.getEnterpriseAccount()
          break
        case '2':
          this.getEnterpriseSeller()
          break
        case '3':
          this.urlApi = `${apiPath.bigData.search.listConcentration}/${this.info.customerNo}`
          this.getPlatform()
          break
        case '4':
          this.getCountryAccount()
          this.urlApi = ``
          break
      }
    },
    // 平台
    async getPlatform () {
      let data = []
      let res = await this.$ajax({
        method: 'get',
        url: this.urlApi
      })
      this.summary2 = res.data
      this.summary2.top10List.forEach(item => {
        data.push({
          value: item.transaction, // 店铺销售额
          // shopName: item.platform,
          shopTotalQuantity: item.storesNum,
          shopTradeAmount: item.transaction,
          // storesNum: item.storesNum
          name: item.platform
        })
      })
      this.setOption(data)
    },
    // 店铺
    getEnterpriseAccount () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.jygl.getEnterpriseAccount}/${this.info.customerNo}`
        // url: `${apiPath.bigData.search.getEnterpriseAccount}/AABK`
      }).then(res => {
        if (res && res.data) {
          let data = []
          this.summary2 = res.data
          this.summary2.top10List.forEach(item => {
            data.push({
              value: item.transaction, // 店铺销售额
              // shopName: item.platform,
              shopTotalQuantity: item.storesNum,
              shopTradeAmount: item.transaction,
              // storesNum: item.storesNum
              name: item.accountName
            })
          })
          this.setOption(data)
        }
      })
    },
    // 主体
    getEnterpriseSeller () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.jygl.getEnterpriseSeller}/${this.info.customerNo}`
        // url: `${apiPath.bigData.search.getEnterpriseSeller}/AABK`
      }).then(res => {
        if (res && res.data) {
          let data = []
          this.summary2 = res.data
          this.summary2.top10List.forEach(item => {
            data.push({
              value: item.transaction,
              // shopName: item.platform,
              shopTotalQuantity: item.storesNum,
              shopTradeAmount: item.transaction,
              // storesNum: item.storesNum
              name: item.sellerId
            })
          })
          this.setOption(data)
        }
      })
    },
    // 国家区
    getCountryAccount () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.jygl.getCountryAccount}/${this.info.customerNo}`
        // url: `${apiPath.bigData.search.getCountryAccount}/AABK`
      }).then(res => {
        if (res && res.data) {
          let data = []
          this.summary2 = res.data
          this.summary2.top10List.forEach(item => {
            data.push({
              value: item.transaction, // 店铺销售额
              // shopName: item.platform,
              shopTotalQuantity: item.accountName,
              shopTradeAmount: item.transaction,
              // storesNum: item.storesNum
              name: item.country
            })
          })
          this.setOption(data)
        }
      })
    },
    // 设置平台的方法
    setOption (data) {
      var chartDom = document.getElementById('jygl-charts2')
      var myChart = this.$echarts.init(chartDom)
      let option
      option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: '8%',
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['50%', '80%'],
            center: ['40%', '40%'],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)
    },
    initCharts3 () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.listShopAmount}`,
        data: {
          'companyName': this.info.companyName,
          'pageNum': 1,
          'pageSize': 10,
          'searchDate': this.searchDate,
          'searchParam': '',
          'sortParam': '',
          'yearTime': this.searchDate
        }
      }).then(res => {
        let list = []
        let data = res.data
        let that = this
        for (let i = 0; i < data.length; i++) {
          list.push({
            name: data[i].shopName,
            color: that.colors[i],
            unit: '',
            value: data[i].shopTradeAmount
          })
        }
        let width = 600
        let nums = list.map(item => {
          item.value = Number(item.value)
          return item.value
        })
        let max = Math.max.apply(null, nums)
        list.map(item => {
          item.width = ((item.value / max) * width) + 'px'
        })
        this.list = list.slice(0, 10)
      })
    },
    // 运营支出汇总表
    initCharts4 () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.js.getOperateExpend}${this.info.customerNo}`
      }).then(res => {
        if (res && res.data) {
          let dataInfo = res.data[0] || []
          var chartDom = document.getElementById('jygl-charts4')
          var myChart = this.$echarts.init(chartDom)
          let data = [
            { value: Math.abs(dataInfo.adsFee), name: '广告费' },
            { value: Math.abs(dataInfo.deliveryFee), name: '配送费' },
            { value: Math.abs(dataInfo.expendOther), name: '支出及其费用' },
            { value: Math.abs(dataInfo.expendPlatform), name: '亚马逊费用' },
            { value: Math.abs(dataInfo.fbaFee), name: 'FBA物流费用' },
            { value: Math.abs(dataInfo.salesRefund), name: '退款拖货费用' },
            { value: Math.abs(dataInfo.taxes), name: '税费' }
          ]
          let numAll = 0
          data.forEach(item => {
            numAll += item.value
          })
          console.log('res.data', data)
          let option = {
            legend: {
              top: 'top',
              textStyle: {
                color: '#fff'
              }
            },
            tooltip: {},
            label: {
              alignTo: 'edge',
              formatter: '{d}%\n{time|{b}}',
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {}
            },
            series: [
              {
                name: '运营支出',
                type: 'pie',
                // radius: [80, 200],
                // center: ['50%', '20%'],
                radius: ['30%', '75%'],
                center: ['50%', '50%'],
                roseType: 'area',
                itemStyle: {
                  // borderRadius: 8
                },
                data: data
              }
            ]
          }
          option && myChart.setOption(option)
          let that = this
          myChart.on('mouseover', function (params) {
            if (params.data.name) {
              let value = ((params.data.value / numAll) * 100).toFixed(2)
              console.log('vavv', value)
              that.tips = value
              that.tipsShow = true
              that.$forceUpdate()
            } else {
              that.tipsShow = false
            }
          })
        }
      })
    },
    getOrderSalesTrend () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.jygl.getOrderSalesTrend}/${this.info.customerNo}`
        // url: `${apiPath.bigData.search.jygl.getOrderSalesTrend}/AABK`
      }).then(res => {
        if (res && res.data) {
          this.initCharts5(res.data)
        }
      })
    },
    initCharts5 (dataInfo) {
      var chartDom = document.getElementById('jygl-charts5')
      var myChart = this.$echarts.init(chartDom)
      let monthTime = dataInfo.map(item => { return item.monthDay })
      let shopTradeAmount = dataInfo.map(item => { return (item.transaction / 10000).toFixed(2) })
      let operatingExpenditureAmount = dataInfo.map(item => { return (item.expend / 10000).toFixed(2) })
      let option
      let data = ['销售额', '支出费用']
      option = {
        // title: {
        //   text: 'Stacked Line'
        // },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let template = ''
            params.forEach((item, index) => {
              if (index === 0) {
                template = item.axisValue + '<br>'
              }
              if (item.seriesType === 'line') {
                item.value += '万元'
              }
              template = template + item.marker + item.seriesName + ' : ' + item.value + '<br>'
            })
            return template
          }
        },
        legend: {
          data: data,
          top: 'top',
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '1%',
          right: '0',
          top: '10%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: monthTime,
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        series: [
          {
            name: data[0],
            type: 'line',
            // stack: 'Total',
            data: shopTradeAmount
          },
          {
            name: data[1],
            type: 'line',
            // stack: 'Total',
            data: operatingExpenditureAmount
          }
        ]
      }
      option && myChart.setOption(option)
    },
    initCharts6 () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.wl.getEnterpriseLogistics}${this.info.customerNo}`

      }).then(res => {
        if (res) {
          let dataInfo = res.data || {}
          // let total = 0
          // let money = 0
          // if (dataInfo.topStorageInventorySummary) {
          //   total = dataInfo.topStorageInventorySummary.inventoryTotalQuantity || 0
          //   money = dataInfo.topStorageInventorySummary.inventoryTotalAmount || 0
          //   dataInfo.topStorageInventorySummarys = {
          //     total: total,
          //     money: money,
          //     inventorySalesRate: dataInfo.topStorageInventorySummary.inventorySalesRate || 0,
          //     turnover: res.data.topStorageInventorySummary.turnover
          //   }
          // }
          this.summary6 = dataInfo
          this.summary6.All = dataInfo.unDeliveredNum + dataInfo.deliveredNum
          var chartDom = document.getElementById('jygl-charts6')
          var myChart = this.$echarts.init(chartDom)
          let option
          let data = [{
            name: '配送中',
            value: this.summary6.unDeliveredNum || 0
          }, {
            name: '已完成',
            value: this.summary6.deliveredNum || 0
          }]
          option = {
            tooltip: {
              trigger: 'item',
              formatter: function (params) {
                return params.marker + params.name + ' : ' + params.value + '次'
              }
            },
            label: {
              alignTo: 'edge',
              formatter: '{name|{c}}次 {d}%\n{time|{b}}',
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {}
            },
            legend: {
              // orient: 'vertical',
              bottom: '2%',
              textStyle: {
                color: '#fff'
              }
            },
            series: [
              {
                name: '配送统计',
                type: 'pie',
                radius: ['40%', '80%'],
                center: ['50%', '45%'],
                data: data,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
          option && myChart.setOption(option)
        }
        // this.initCharts7()
        // this.initCharts8()
        // this.initCharts9()
        // this.initCharts10()
      })
    },
    initCharts7 () {
      var chartDom = document.getElementById('jygl-charts7')
      // topCusCustomsSummary
      const declareSummary = this.declareSummary.data
      var myChart = this.$echarts.init(chartDom)
      let option
      let data = []
      declareSummary.forEach(item => {
        data.push({
          name: item.orderType,
          value: item.declarationNum
        })
      })
      // let data = [{
      //   name: '9610',
      //   value: 0
      // }, {
      //   name: '9710',
      //   value: 0
      // }, {
      //   name: '9810',
      //   value: 0
      // }, {
      //   name: '1210',
      //   value: 0
      // }]
      // for (let i of declareSummary) {
      //   for (let e of data) {
      //     if (i.orderType !== e.name) continue
      //     e.value = i.declarationNum
      //   }
      // }
      option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.marker + params.name + ' : ' + params.value + '单'
          }
        },
        // grid: {
        //   top: '10%',
        //   left: '2%',
        //   right: '2%',
        //   bottom: '0%',
        //   containLabel: true
        // },
        legend: {
          // orient: 'vertical',
          bottom: '2%',
          textStyle: {
            color: '#fff'
          }
        },
        label: {
          alignTo: 'edge',
          formatter: '{name|{c}}单 {d}%\n{time|{b}}',
          minMargin: 5,
          edgeDistance: 10,
          lineHeight: 15,
          rich: {
            // time: {
            //   fontSize: 10,
            //   color: '#999'
            // },
            // name: {
            //   fontSize: 10,
            //   color: '#999'
            // }
          }
        },
        series: [
          {
            name: '报关统计',
            type: 'pie',
            radius: ['40%', '80%'],
            center: ['50%', '45%'],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)
    },
    // 仓储库存统计
    loadEnterpriseGoodsStored () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.cc.getEnterpriseGoodsStored}${this.info.customerNo}`
      }).then(res => {
        this.enterpriseGoodsStored = res.data || {}
        this.initCharts8()
      })
    },
    initCharts8 () {
      var chartDom = document.getElementById('jygl-charts8')
      var myChart = this.$echarts.init(chartDom)
      let option
      let data = [
        {
          name: '',
          value: this.enterpriseGoodsStored.availableQty || 0
        }
      ]
      option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.marker + params.name + ' : ' + params.value + '件'
          }
        },
        legend: {
          bottom: '1%',
          textStyle: {
            color: '#fff'
          }
        },
        label: {
          alignTo: 'edge',
          formatter: '{time|{b}} {name|{c}}件',
          minMargin: 5,
          edgeDistance: 10,
          lineHeight: 15,
          rich: {}
        },
        series: [
          {
            name: '仓储库存统计',
            type: 'pie',
            radius: ['40%', '80%'],
            center: ['50%', '45%'],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)
    },
    // 授信统计
    loadEnterpriseLoans () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.jygl.getEnterpriseLoans}${this.info.customerNo}`
      }).then(res => {
        this.initCharts9()
        if (res.data) {
          let obj = res.data
          this.enterpriseLoans = obj
          this.enterpriseLoans.creditAmount = (obj.creditAmount / 10000).toFixed(2)
          this.enterpriseLoans.loanAmount = (obj.loanAmount / 10000).toFixed(2)
          this.enterpriseLoans.loanBalance = (obj.loanBalance / 10000).toFixed(2)
          this.enterpriseLoans.creditBalance = (obj.creditBalance / 10000).toFixed(2)
          this.enterpriseLoans.overdueInterests = (obj.overdueInterests / 10000).toFixed(2)
        } else {
          this.enterpriseLoans = {}
        }
      })
    },
    loadDeclareSummary () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.bg.getDeclarationType}`,
        data: {
          customerNo: this.info.customerNo
        }
      }).then(res => {
        const dataInfo = res.data || []
        this.declareSummary = {
          data: dataInfo
        }
        this.declareSummary.customsTimes = dataInfo.reduce((total, cur) => {
          return Number(total) + Number(cur.declarationNum)
        }, 0)
        this.declareSummary.customsCommoditiesPiece = dataInfo.reduce((total, cur) => {
          return Number(total) + Number(cur.goodsNum)
        }, 0)
        this.initCharts7()
      })
    },
    initCharts9 () {
      var chartDom = document.getElementById('jygl-charts9')
      var myChart = this.$echarts.init(chartDom)
      let option
      let data = [
        {
          name: '现有贷款',
          value: this.enterpriseLoans.loanBalance || 0
        }, {
          name: '剩余授信',
          value: this.enterpriseLoans.creditBalance || 0
        }
      ]
      option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.marker + params.name + ' : ' + params.value + '笔'
          }
        },
        label: {
          alignTo: 'edge',
          formatter: '{name|{c}} {d}%\n{time|{b}}',
          minMargin: 5,
          edgeDistance: 10,
          lineHeight: 15,
          rich: {}
        },
        legend: {
          bottom: '0',
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: '授信统计',
            type: 'pie',
            radius: ['40%', '80%'],
            center: ['50%', '45%'],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)
    },
    loadEnterpriseAccountSummary () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.js.getEnterpriseAccountSummary}${this.info.customerNo}`
      }).then(res => {
        this.enterpriseAccountSummary = res.data || {}
        this.enterpriseAccountSummary.settledTotal = (res.data.settledTotal / 10000).toFixed(2)
        this.initCharts10()
      })
    },
    initCharts10 () {
      var chartDom = document.getElementById('jygl-charts10')
      var myChart = this.$echarts.init(chartDom)
      let option
      let data = [
        // {
        //   name: '结算总额',
        //   value: this.summary6.topTotalAmountSummary.settledTotal
        // }, {
        //   name: '结算商品',
        //   value: this.summary6.topTotalAmountSummary.settledCommoditiesQuantity
        // }, {
        //   name: '结算笔数',
        //   value: this.summary6.topTotalAmountSummary.settlementQuantity
        // }
        {
          name: '已结算金额',
          value: this.enterpriseAccountSummary.settledAmount || 0
        }, {
          name: '未结算金额',
          value: (this.enterpriseAccountSummary.settledTotal - this.enterpriseAccountSummary.settledAmount).toFixed(2) || 0
        }
      ]
      option = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return params.marker + params.name + ' : ' + (params.value / 10000).toFixed(2) + '万元'
          }
        },
        legend: {
          // orient: 'vertical',
          // formatter: '{value}万元',
          bottom: '0',
          textStyle: {
            color: '#fff'
          }
        },
        label: {
          alignTo: 'edge',
          formatter: '{name|{c}} {d}%\n{time|{b}}',
          minMargin: 5,
          edgeDistance: 10,
          lineHeight: 15,
          rich: {
            // time: {
            //   fontSize: 10,
            //   color: '#999'
            // },
            // name: {
            //   fontSize: 10,
            //   color: '#999'
            // }
          }
        },
        series: [
          {
            name: '结算统计',
            type: 'pie',
            radius: ['40%', '80%'],
            center: ['50%', '45%'],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)
    }
  }
}
</script>

<style lang='scss' scoped>
  .jygl{
    padding:0 20px;
    .content{
      border: 1px solid rgb(71,166,234);
      border-radius: 6px;
      padding: 16px 20px 32px 20px;
      margin:32px 0 16px 0;
      position: relative;
      .top{
        display: flex;
        font-size:18px;
        position: relative;
        .icon{
          width: 20px;
          height: 20px;
          border-radius: 4px;
          background: rgb(71,166,234);
          margin-right:16px;
        }
        .right{
          position: absolute;
          right:-4px;
          top: -2px;
        }
      }
      .row{
        display: flex;
        margin-top: 32px;
        position: relative;
        .tips{
          position: absolute;
          top: calc(50% - 20px);
          display: flex;
          flex-direction: column;
          align-items: center;
          left:360px;
          font-size:22px;
        }
        .texts{
          width: 260px;
          font-size:20px;
          margin-top:12px;
          // margin-right: 20px;
          margin-left: 10px;
          div{
            margin-bottom: 32px;
          }
        }
      }
      .title{
        text-align: center;
        display: flex;
        justify-content: space-around;
        padding: 0 100px;
        margin-top:20px;
        font-size:18px;
      }
    }
    .line1{
      display: flex;
      height: 440px;
      margin-bottom:72px;
    }
    .line2{
      display: flex;
      height: 726px;
      margin:32px 0 72px 0;
    }
    .w-70{
      width: 1050px;
      height: 100%;
      margin-right:20px;
      // margin-left:32px;
    }
    .w-30{
      width: 710px;
      height: 100%;
      margin-right:16px;
      // margin-left:32px;
    }
    .w-33{
      width: 577px;
      height: 100%;
      margin-right:16px;
      // margin-left:32px;
    }
    .w-50{
      width: 880px;
      height: 100%;
    }
    .w-100{
      width: 100%;
      height: 100%;
      margin-right:32px;
      // margin-left:32px;
    }
    #jygl-charts1{
      margin-top:16px;
      width: 100%;
      height: 400px;
    }
    #jygl-charts2{
      position: absolute;
      left:0;
      width: 100%;
      height: 370px;
      bottom:0;
    }

    #jygl-charts3{
      margin:24px 32px 16px 32px;
      height: 700px;
      .item{
        margin-bottom:12px;
        color:#fff;
        font-size:12px;
        .top{
          display: flex;
          align-items: center;
          font-size:16px;
        }
        .index{
          width: 24px;
          height:24px;
          line-height:24px;
          text-align: center;
          border-radius: 50%;
          margin-right: 16px;
        }
        .name{
          margin-right: 16px;
          min-width: 100px;
        }
        .unit{
          color: rgb(71,166,234);
        }
        .bottom{
          font-size:18px;
          display: flex;
          align-items: center;
          margin: 6px 0 16px 46px;
        }
        .line{
          height:16px;
          border-radius: 10px;
          min-width: 20px;
          margin-right: 10px;
        }
      }
    }

    #jygl-charts4{
      margin-top:20px;
      width: 800px;
      // margin-right:32px;
      height: 320px;
    }

    #jygl-charts5{
      // margin-top:20px;
      width: 1024px;
      height: 340px;
    }

    #jygl-charts6{
      margin-top:20px;
      width: 100%;
      height: 385px;
    }

    #jygl-charts7{
      margin-top:20px;
      width: 100%;
      height: 385px;
    }

    #jygl-charts8{
      // margin-top:20px;
      width: 100%;
      height: 355px;
    }

    #jygl-charts9 {
      width: 650px;
      height: 400px;
    }
    #jygl-charts10{
      width: 650px;
      height: 400px;
    }

  }
</style>
<style lang='scss'>
  .jygl{
    .el-radio-button__inner{
      background: transparent !important;
      color:#fff !important;
      padding:6px 16px;
    }
    .el-radio-button__orig-radio:checked+.el-radio-button__inner{
      background: #01AFEC !important;
      border-color: #01AFEC !important;
    }
  }
</style>
<style lang='scss'>
  .commonDialog{
    // width: 1410px;
    // height: 745px;
    margin-top: 0;
    margin-bottom: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2018;
    position: absolute;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    .el-dialog__header{
      display: none;
      padding:0;
    }
    .el-dialog__body{
      position: relative;
      padding: 0;
      height: 100%;
    }
    .mask{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      border-radius: 0px;
      background: rgba(0, 0, 0, 0.5);
    }
    .ux-panel{
      position: relative;
      z-index: 1;
      padding-top: 70px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border: 1px solid #22bdfe;
      background: rgba(17, 47, 72, 0.9);
      .head-list{
        display: flex;
        margin-top: 32px;
        justify-content: space-between;
        padding: 0 150px;
        color:#fff;
        font-size:24px;
      }
      .title{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .title::after {
        position: absolute;
        content: "";
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 30px * 2);
        height: 0;
        border: 1px solid;
        border-image: linear-gradient(63deg, rgba(71, 241, 255, 0), #38c2ff, rgba(34, 222, 254, 0)) 1 1;
      }
      .tabs{
        padding: 0 30px;
        box-sizing: border-box;
        .tabs-header{
          // margin-bottom:20px;
          text-align: center;
        }
        .tabs-header {
          .ux-dark-el-radio {
            .is-active,
            .is-focus {
              span {
                color: #ffffff;
                box-shadow: -1px 0 0 0 #1c8be2;
                border-color: #1c8be2;
                background-color: #1c8be2;
              }
            }
            span {
              padding: 9px 12px;
              font-size: 16px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #2bb0f0;
              border-color: #2d6bab;
              background: rgba(24, 127, 215, 0.2);
            }
          }
          .el-radio-button__inner{
            margin: 0 4px;
            padding: 10px 12px;
            font-size: 18px;
            border-radius: 0px 0px 4px 4px;
            color: #2bb0f0;
            border: 1px solid #2d6bab;
            background: rgba(24, 127, 215, 0.2);
          }
          .el-radio-group{
            font-size: 0
          }
        }
        .tabs-pane {
          .el-tabs {
            .el-tabs__header {
              display: none;
            }
          }
          .ux-table-wrap {
          }
        }
        table {
          .cell {
            padding: 12px 10px;
          }
          .el-table__cell{
             border-right: 1px solid #2d6bab;
             border-bottom: 1px solid #2d6bab;
          }
          th .cell {
            text-align: center;
            font-size: 18px !important;
          }
        }
      }
      .close{
        position: absolute;
        right: 20px;
        top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: content-box;
        padding: 5px;
        width: 24px;
        height: 24px;
        cursor: pointer;
        img{
          width: 30px;
          height: 30px;
        }
      }
    }
    .ux-filter-records {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px 30px 0;
    box-sizing: border-box;
    .filter {
      display: flex;
      flex-wrap: wrap;
      // div {
      //   margin-right: 18px;
      //   margin-bottom: 10px;
      // }
      .search {
        color: #ffffff;
        background: #1c8be2;
      }
    }
    .content-list {
      margin-top: 10px;
      flex: none;
      // min-height: 550px;
      .table {
        height: 100%;
        .el-table__header-wrapper {
          tr {
            th {
              height: 50px;
            }
          }
        }
        .el-table__body-wrapper {
          tr {
            td {
              height: 50px;
            }
          }
        }
        .el-loading-mask {
          /* background: rgba(0, 0, 0, 0.8); */
          .el-loading-spinner {
            font-size: 24px;
          }
        }
        .text {
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .ux-dark-el-table {
        display: flex;
        flex-direction: column;
        border: 1px solid #2d6bab;
        background-color: transparent;
        table {
          tr {
            background: rgba(24, 127, 215, 0.1) !important;
            &:last-child {
              td {
                border-bottom: none;
              }
            }
            th {
              padding: 0;
              border-color: #2d6bab !important;
              background: rgba(24, 127, 215, 0.3) !important;
              &:last-child {
                border-right: none;
              }
              .cell {
                font-size: 16px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color:#fff;
                // background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
                // background-clip: text;
                // -webkit-text-fill-color: transparent;
              }
            }
            td {
              padding: 0;
              font-size: 14px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: #ffffff;
              border-color: #2d6bab;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        td.el-table__cell{
          border-bottom: 1px solid #2d6bab;
        }
        &::before {
          display: none;
        }
        // tbody row hover
        &.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
          background: rgba(24, 127, 215, 0.2);
        }
        // 多级表头
        &.el-table--group::after,
        // 带边框表格
        &.el-table--border::after {
          content: unset;
        }
        .el-table__body-wrapper {
          flex: 1 1;
          table {
            height: 100%;
          }
        }
        .el-table__footer-wrapper tbody td.el-table__cell {
          font-size: 16px;
          background-color: transparent;
        }
      }
    }
    .pages {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 28px;
      font-size: 16px;
      font-weight: 400;
      color: #fff;
    }
  }
  }
  .el-input-dark {
    .el-input__inner{
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
      border: 1px solid #2d6bab;
      background: rgba(24, 127, 215, 0.2);
      padding: 0 15px !important;
    }
    .search {
        color: #ffffff;
        background: #1c8be2;
    }
    .el-input__wrapper{
      padding: 0 !important;
      margin-bottom:0 !important;
      box-shadow: none !important;
    }
    .el-input--suffix{
      margin-bottom:0 !important;
    }
    .el-input__suffix {
      right: 5px;
      transition: all .3s;
      position: absolute;
      top: 0;
      height: 100%;
      color: #C0C4CC;
      text-align: center;
    }
    .select-trigger{
      margin-bottom:0 !important;
    }
  }
  .el-btn-dark{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 36px;
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #2bb0f0;
    border: 1px solid #2d6bab;
    background: transparent;
    &:focus,
    &:hover {
      color: #2bb0f0;
      border-color: #2d6bab;
      background: transparent;
    }
  }
  .ux-dark-el-pagination {
    padding-right: 0;
    .btn-prev,
    .el-pager li,
    .el-pager li:last-child,
    .el-pager li.active,
    .btn-next {
      min-width: 28px !important;
      min-height: 28px !important;
      line-height: 26px !important;
      font-size: 16px !important;
      color: #ffffff !important;
      border: 1px solid #2d95ea;
      background-color: transparent !important;
    }
    .el-pager li.active {
      background: #1c8be2 !important;
    }
    .btn-next {
      margin-right: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/jygl.vue